<svelte:options
  customElement={{
    tag: "modal-contents",
    shadow: "none"
  }}
/>

<script>
  const crossIcon = "/assets_default/icons/cross.svg"
  let {
    contentstype = '',
    contentsid = '',
  } = $props();
</script>

<div class="owd-modal" data-modal-contents-type="{contentstype}">
  <div class="owd-modal-container">
    <div class="owd-modal-close:area">
      <img class="owd-modal-close:button" src="{crossIcon}" alt="クロスアイコン" data-owd-modal="closeButton">
    </div>
    <div class="owd-modal-wrapper">
      <div id="{contentsid}"></div>
    </div>
    <p class="owd-modal-close:label owd-text:02" data-owd-modal="closeButton"><strong class="owd-textlink">閉じる</strong></p>
  </div>
</div>
